import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { ActionServiceService } from '../../suivi/plananalytique/actions/action/action.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Pdc } from 'src/app/shared/models/pdc';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-add-pdc',
  standalone: false,
  templateUrl: './add-pdc.component.html',
  styleUrl: './add-pdc.component.scss'
})



export class AddPdcComponent {


  constructor(
    private modalService: NgbModal,

    private paramService: ParameterService,
    private messageService: MessageService,
    private ActionServiceService: FecthDataService,
    private ngxService: NgxUiLoaderService,



  ) {

  }

  ngOnInit() {
  }

  close() {

    this.modalService.dismissAll();
  }

  item: Pdc = new Pdc();
  programmeData: any = []
  agenceData: any = [];
  resultatItems: any = [];
  fileName: string = '';


  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.item.photo = file;

    }
  }
  addPdc() {

    if (!this.item.canSend()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    } else {


      const formData = new FormData();
      formData.append('titre_projet', this.item.titre_projet);
      formData.append('description_projet', this.item.description_projet);
      formData.append('nom_bailleur', this.item.nom_bailleur);
      formData.append('lien_article', this.item.lien_article);
      formData.append('photo', this.item.photo);
      this.ngxService.start();
      this.paramService.addPdc(formData).subscribe(
        (response: any) => {
        
          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.ActionServiceService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error: any) => {
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });
          this.ActionServiceService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
    }

  }


}